"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTemplateSchema = exports.FormBuilderData = void 0;
const model_schema_1 = require("../base/model.schema");
const yup_1 = require("yup");
exports.FormBuilderData = (0, yup_1.object)({
    title: (0, yup_1.string)().notRequired(),
    allowSummary: (0, yup_1.boolean)().notRequired(),
    sections: (0, yup_1.array)((0, yup_1.mixed)()).notRequired(),
    passPercentage: (0, yup_1.number)().min(0).notRequired()
});
exports.FormTemplateSchema = model_schema_1.Schema.shape({
    companyID: (0, yup_1.string)().required(),
    formType: (0, yup_1.string)().required(),
    channel: (0, yup_1.string)().required(),
    form: exports.FormBuilderData.notRequired(),
    name: (0, yup_1.string)().notRequired()
});
